module.exports = __webpack_public_path__ + "img/confirm.4a32bad1.jpg";